module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#magazines",
      toString: function () {
        return this.url;
      }
    }